import { AxiosResponse } from "axios";
import axiosApiInstance from "src/api/axiosInstance.api";
import { IGenericImport } from "src/models/General/registerGroup.models";
import { IStore } from "src/models/Stores/Store.models";
import { IApiResponse } from "src/shared/models/IApiResponse";

export interface IStoreSingleApiResponse extends IApiResponse {
  data: IStore;
}

export interface IStoreListApiResponse extends IApiResponse {
  data: IStore[];
}

const responseBody = (response: AxiosResponse) => response.data;

const requests = {
  get: (url: string, params?: any) =>
    axiosApiInstance.get(url, { params: params }).then(responseBody),
  post: (url: string, body: {}) =>
    axiosApiInstance.post(url, body).then(responseBody),
  put: (url: string, body: {}) =>
    axiosApiInstance.put(url, body).then(responseBody),
  del: (url: string) => axiosApiInstance.delete(url).then(responseBody),
};

const StoreAPIService = {
  getAll: (params?: any): Promise<IStoreListApiResponse> =>
    requests.get("/stores/getAll", params),
  getById: (id: number): Promise<IStoreSingleApiResponse> =>
    requests.get(`/stores/getById/${id}`),
  create: (body: IStore): Promise<IStoreSingleApiResponse> =>
    requests.post(`/stores/create`, body),
  massiveCreate: (body: IGenericImport[]): Promise<IStoreListApiResponse> =>
      requests.post(`/massiveUploads/create-stores`, body),
  update: (body: IStore): Promise<IStoreSingleApiResponse> =>
    requests.put(`/stores/update`, body),
  restore: (body: number): Promise<IStoreSingleApiResponse> =>
    requests.put(`/stores/restore`, body ),
};

export { StoreAPIService };
